import sms from './sms'
import email from './email'
import notification from './notification'
import order from './order'
import payment from './payment'

export default {
  name: 'SystemGateway',
  path: 'gateway',
  meta: {
    label: 'webServices',
    auth: 'gateway'
  },
  component: {
    name: 'Gateway',
    render(c) {
      return c('router-view')
    }
  },
  children: [sms, email, notification, payment, order]
}
